import { Plus } from '@sqs/rosetta-icons';
import { Button } from '@sqs/rosetta-primitives';
import React from 'react';
import { usePlatformBreakpoint } from '../../../hooks/usePlatformBreakpoint';
import { useI18n } from '../../../i18n';

interface AddUserToInstanceButtonProps {
  readonly onClick: () => void;
  readonly showFullButton?: boolean;
  readonly disabled?: boolean;
}

export const AddUserToInstanceButton = ({ onClick, showFullButton, disabled }: AddUserToInstanceButtonProps) => {
  const { isMobile } = usePlatformBreakpoint();
  const { T, t } = useI18n();

  if (showFullButton || !isMobile) {
    return (
      <Button.Primary size="large" type="button" onClick={onClick} disabled={disabled}>
        <Plus color="white" />
        &nbsp;
        <T project="enterprise-dashboard">{"Add User"}</T>
      </Button.Primary>);

  }
  return (
    <Button.Tertiary
      type="button"
      onClick={onClick}
      size="small"
      disabled={disabled}
      aria-label={t("Add User", {}, { project: 'enterprise-dashboard' })}>

      <Plus />
    </Button.Tertiary>);

};